module.exports = __webpack_public_path__ + "img/behance cover.fbfa249e.png";